import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { LoadingService } from '@smartera/core';

@Component({
	selector: 'error-page',
	templateUrl: './error-page.component.html',
	styleUrls: ['./error-page.component.scss'],
	imports: [CommonModule, TranslateModule, ButtonDirective],
})
export class ErrorPageComponent implements OnInit {
	protected errorCode: number;
	protected errorMessage = '';

	protected isNormalError: boolean;
	protected isButtonError: boolean;

	private readonly _activatedRoute = inject(ActivatedRoute);
	private readonly router = inject(Router);
	private readonly loadingService = inject(LoadingService);

	public ngOnInit(): void {
		this._activatedRoute.data.subscribe((data: { code: number; message: string }) => {
			this.errorCode = data.code;
			this.errorMessage = data.message;
			if (+data.code === 403 || +data.code === 404) {
				this.isNormalError = true;
				this.isButtonError = true;
			}
			this.loadingService.hideLoading();
		});
	}

	protected returnToPage(): void {
		if (this.errorCode === 408) {
			this.router.navigateByUrl('/login');
		} else {
			this.router.navigateByUrl('/page/dashboard');
		}
	}
}
